import * as React from 'react'
import YouTube from 'react-youtube'
import './MarkupEmbeddedVideo.scss'

interface IMarkupEmbeddedVideoProps {
  className?: string
  tag?: string
  text: string
}

export default class MarkupEmbeddedVideo extends React.PureComponent<
  IMarkupEmbeddedVideoProps
> {
  public render() {
    const { tag, text, ...props } = this.props

    if (!text) {
      return null
    }

    const youtubeRegex = /((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?\s]*)/g
    const children = []

    let match = youtubeRegex.exec(text)

    while (match !== null) {
      if (match[7] && match[7].length === 11) {
        const videoId = match[7]

        children.push(
          <div className='embedded-video-player' key={`youtube-${videoId}`}>
            <div className='video-player-container'>
              <YouTube
                key={`youtube-${videoId}`}
                className='video-player'
                videoId={videoId}
                opts={{ width: '100%', height: '100%' }}
              />
            </div>
          </div>,
        )
      }

      match = youtubeRegex.exec(text)
    }

    if (children.length === 0) {
      return null
    }

    return React.createElement(tag || 'div', props, children)
  }
}
